"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _tokens = require("../styles/tokens");
var _excluded = ["classes", "variant"];
var styles = function styles(theme) {
  return {
    root: {
      borderColor: theme.palette.grey[400],
      marginTop: _tokens.spacing40,
      marginBottom: _tokens.spacing40
    },
    fullWidth: {},
    middle: {
      marginLeft: _tokens.spacing40,
      marginRight: _tokens.spacing40
    }
  };
};

/**
 * Use `Divider` to group and separate content within lists and page layouts.
 * @done true
 * @updated v7.0.0
 * @versionAdded v0.0.11
 * @examples
 *  FullWidthDividerExample
 *  MiddleDividerExample
 */
var Divider = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
    variant = props.variant,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = {
    root: classes.root,
    fullWidth: classes.fullWidth,
    middle: classes.middle
  };
  return /*#__PURE__*/_react.default.createElement(_Divider.default, (0, _extends2.default)({}, rest, {
    variant: variant,
    classes: classOverrides,
    ref: ref
  }));
});
Divider.muiName = 'Divider';
Divider.displayName = 'Divider';
Divider.propTypes = {
  /**
   * Absolutely position the element.
   */
  absolute: _propTypes.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * The component used for the root node.
   * Use an HTML element or a component.
   */
  component: _propTypes.default.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object]),
  /**
   * @ignore
   *
   * The text alignment.
   */
  textAlign: _propTypes.default.oneOf(['center', 'left', 'right']),
  /**
   * Specifies Divider styling.
   */
  variant: _propTypes.default.oneOf(['fullwidth', 'middle'])
};
Divider.defaultProps = {
  variant: 'fullwidth',
  component: 'hr',
  absolute: false
};
var _default = (0, _styles.default)(styles)(Divider);
exports.default = _default;